import React from 'react';
import { useTranslation } from 'react-i18next';
import { HistoryTab } from '@/hooks/useHistory';
import { TabCounts } from '@/hooks/useHistory';
import './HistoryTabs.scss';

interface HistoryTabsProps {
  activeTab: HistoryTab;
  onTabChange: (tab: HistoryTab) => void;
  tabCounts: TabCounts;
}

const HistoryTabs: React.FC<HistoryTabsProps> = ({ activeTab, onTabChange, tabCounts }) => {
  const { t } = useTranslation('home');

  const tabs = [
    { id: 'all' as HistoryTab, label: t('history.tabs.all'), count: tabCounts.all },
    { id: 'specification' as HistoryTab, label: t('history.tabs.specification'), count: tabCounts.specification },
    { id: 'engagement' as HistoryTab, label: t('history.tabs.engagement'), count: tabCounts.engagement },
    { id: 'tagSubmissions' as HistoryTab, label: t('history.tabs.tagSubmissions'), count: tabCounts.tagSubmissions },
  ];

  return (
    <div className="history-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`history-tabs__tab ${activeTab === tab.id ? 'history-tabs__tab--active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {`${tab.label} (${tab.count})`}
        </button>
      ))}
    </div>
  );
};

export default HistoryTabs;
